import type { RouteRecordRaw } from 'vue-router'
import { ADMIN_RBAC_PERMISSIONS } from '@/config/admin/rbac'

export const adminFinanceRoutes: RouteRecordRaw[] = [
  {
    path: 'finance/withdrawals',
    name: 'AdminWithdrawalReviewList',
    component: () => import('@/views/admin/finance/WithdrawalReviewListPage.vue'),
    meta: {
      title: '提现申请',
      sidebarId: 'withdrawal-review',
      permissions: [ADMIN_RBAC_PERMISSIONS.FINANCE_WITHDRAW_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
  {
    path: 'finance/withdrawals/:id',
    name: 'AdminWithdrawalReviewDetail',
    component: () => import('@/views/admin/finance/WithdrawalReviewDetailPage.vue'),
    meta: {
      title: '提现申请详情',
      sidebarId: 'withdrawal-review',
      permissions: [ADMIN_RBAC_PERMISSIONS.FINANCE_WITHDRAW_VIEW],
      breadcrumb: true,
    },
  },
  {
    path: 'finance/refunds',
    name: 'AdminRefundReviewList',
    component: () => import('@/views/admin/finance/RefundReviewListPage.vue'),
    meta: {
      title: '退款申请',
      sidebarId: 'refund-review',
      permissions: [ADMIN_RBAC_PERMISSIONS.FINANCE_WITHDRAW_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
  {
    path: 'finance/refunds/:id',
    name: 'AdminRefundReviewDetail',
    component: () => import('@/views/admin/finance/RefundReviewDetailPage.vue'),
    meta: {
      title: '退款申请详情',
      sidebarId: 'refund-review',
      permissions: [ADMIN_RBAC_PERMISSIONS.FINANCE_WITHDRAW_VIEW],
      breadcrumb: true,
    },
  },
]
